export function getAreaNamesFromData(data) {
    return (data === null || data === void 0 ? void 0 : data.length) ? data.map(item => item.name) : [];
}
